<div [ngSwitch]="currentDocumentView$ | async" style="height: calc(100% - 38px)">
  <lex-doc-viewer-information-bar></lex-doc-viewer-information-bar>
  <lex-doc-viewer-original-content *ngSwitchCase="'original'"></lex-doc-viewer-original-content>
  <lex-doc-viewer-html-content *ngSwitchCase="'html'"></lex-doc-viewer-html-content>
  <lex-doc-viewer-page-content *ngSwitchCase="'pages'"></lex-doc-viewer-page-content>
  <lex-doc-viewer-pdf-content *ngSwitchCase="'pdf'"></lex-doc-viewer-pdf-content>
  <lex-doc-viewer-text-component *ngSwitchCase="'text'"></lex-doc-viewer-text-component>
  <lex-doc-viewer-produced-content *ngSwitchCase="'produced'"></lex-doc-viewer-produced-content>
  <lex-doc-viewer-translated-content *ngSwitchCase="'translated'"></lex-doc-viewer-translated-content>
    <lex-doc-viewer-redaction-content *ngSwitchCase="'redacted'"></lex-doc-viewer-redaction-content>
   <lex-doc-viewer-annotation-content *ngSwitchCase="'annotated'"></lex-doc-viewer-annotation-content>
  <lex-doc-viewer-compare-content *ngSwitchCase="'text-compare'"></lex-doc-viewer-compare-content>
</div>
